import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  // Skip if Authorization header is already set
  if (config.headers.Authorization) {
    return config;
  }

  // Try JWT token first
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (window.Telegram?.WebApp?.initData) {
    // Fallback to TMA authentication
    const initData = window.Telegram.WebApp.initData;
    config.headers.Authorization = `tma ${initData}`;
  }

  return config;
});

// Auth
export const authenticate = async (initData) => {
  const response = await api.post('/auth/telegram', { initData });
  const { access_token, user } = response.data;
  localStorage.setItem('token', access_token);
  return { token: access_token, user };
};

// User
export const getCurrentUser = () => api.get('/user/me');
export const getUserSettings = () => api.get('/user/settings');
export const updateUserSettings = (settings) => api.put('/user/settings', settings);
export const getUserStats = () => api.get('/user/stats');
export const getInviteInfo = () => api.get('/user/invite-info');

// VERA Points
export const getVeraBalance = () => api.get('/vera/balance');
export const getVeraTransactions = (params) => api.get('/vera/transactions', { params });

// Configurations
export const getConfigurations = (params) => api.get('/configurations', { params });
export const getRecommendedConfigurations = () => api.get('/configurations/recommended');
export const getConfiguration = (id) => api.get(`/configurations/${id}`);

// Tests
export const createTest = (testData) => api.post('/tests', testData);
export const getMyTests = (params) => api.get('/tests/my', { params });

export default api;
